export const getMunicipalities = state => state.municipality.municipalityList;
export const getMunicipalityDetails = (state) =>
  state.municipality.municipalityDetails;
export const getCurrentMunicipality = (state) =>
  state.municipality.currentMunicipality;
